import { useEffect } from 'react';
import { browserName } from 'react-device-detect';
import { SessionContext } from '../canonical/SessionContext';
import { metricsPublisher } from '../metrics';
import { DIMENSION_KEYS, METRIC_NAME } from '../types';

interface PropsType {
  children: JSX.Element;
}

/**
 * App initialization wrapper that sets up early metrics dimensions.
 */
export const AppInitWrapper: React.FC<PropsType> = ({ children }) => {
  useEffect(() => {
    SessionContext.init();

    metricsPublisher.addGlobalDimensions({
      [DIMENSION_KEYS.BROWSER]: browserName,
    });

    // Emit browser count with dimensions
    metricsPublisher.emitCount(METRIC_NAME.BROWSER_COUNT);
  }, []);

  return children;
};

export default AppInitWrapper;
